import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-ml-3 p-mr-3 p-mt-3" }
const _hoisted_2 = { class: "p-text-center" }
const _hoisted_3 = {
  key: 0,
  class: "p-my-2"
}
const _hoisted_4 = {
  key: 0,
  class: "p-error"
}
const _hoisted_5 = {
  key: 1,
  class: "p-error"
}
const _hoisted_6 = { class: "p-p-3 shadow bg-color-secondary rounded" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-jc-between p-mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", null, "รายละเอียดการชำระเงิน")
  ])
], -1)
const _hoisted_8 = { class: "p-d-flex p-jc-between p-mb-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "จำนวนเงิน")
], -1)
const _hoisted_10 = {
  key: 0,
  class: ""
}
const _hoisted_11 = {
  key: 1,
  class: ""
}
const _hoisted_12 = {
  key: 0,
  class: "p-d-flex p-jc-between p-mb-2"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createElementVNode("span", null, "หลังฐานการโอน")
], -1)
const _hoisted_14 = { class: "w-90" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "p-d-flex p-jc-between p-mb-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", null, "ช่องทางการชำระเงิน", -1)
const _hoisted_22 = { class: "p-d-flex p-jc-between p-mb-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", null, "สถานะการชำระเงิน", -1)
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "p-mt-2" }
const _hoisted_27 = { class: "p-mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransactionCompleteHeader = _resolveComponent("TransactionCompleteHeader")!
  const _component_TransactionCartDetail = _resolveComponent("TransactionCartDetail")!
  const _component_TransactionAddressDetails = _resolveComponent("TransactionAddressDetails")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_TransactionCompleteHeader, {
        transactionInvoice: _ctx.transaction.invoiceNo,
        statusId: _ctx.transaction.statusId,
        statusName: _ctx.transaction.statusName
      }, null, 8, ["transactionInvoice", "statusId", "statusName"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.transaction.statusId === 7)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_ctx.transaction.reasonNote !== '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, " ยกเลิกคำสั่งซื้อเนื่องจาก : " + _toDisplayString(_ctx.transaction.reasonNote), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, "ยกเลิกคำสั่งซื้อ"))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", null, [
            (_ctx.transferSlip && _ctx.transferSlip.amount !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.transferSlip.amount) + " บาท ", 1))
              : (_ctx.transaction && _ctx.transaction.grandTotal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.transaction.grandTotal) + " บาท ", 1))
                : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.transaction.paymentMethodId == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                (_ctx.transferSlip.imageList.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transferSlip.imageList, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index + 'fileupload'
                        }, [
                          _createElementVNode("img", {
                            class: "m-1",
                            src: item.imageUrl,
                            style: {"height":"auto","width":"100%"},
                            alt: ""
                          }, null, 8, _hoisted_16),
                          _hoisted_17
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, "-"))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.transaction.paymentMethodId !== 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", null, _toDisplayString(_ctx.transaction.paymentName), 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", null, [
                  (_ctx.transaction.statusId == 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, " ดำเนินการชำระเงินสำเร็จ "))
                    : _createCommentVNode("", true),
                  (_ctx.transaction.statusId == 8)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, " ดำเนินการชำระเงินไม่สำเร็จ "))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_component_TransactionCartDetail, {
          transaction: _ctx.transaction,
          isShowCart: true
        }, null, 8, ["transaction"])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_TransactionAddressDetails, {
          buyerInfo: _ctx.transaction.buyerInfo,
          isDisplayAddress: true
        }, null, 8, ["buyerInfo"])
      ])
    ])
  ]))
}